import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isConnected: false,
  account: null,
  ethereum: null,
  bech32Address: null,
  profile: null,
  wallet: null,
};

export const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setConnect: (state, action) => {
      state.account = action.payload.account;
      state.wallet = action.payload.wallet;
      state.isConnected = true;
    },
    setEthereum: (state, action) => {
      state.ethereum = action.payload;
    },
    setBech32Address: (state, action) => {
      state.bech32Address = action.payload;
    },
    setDisconnect: (state, action) => {
      state.account = null;
      state.isConnected = false;
      state.wallet = null;
      state.ethereum = null;
      state.bech32Address = null;
    },
    setProfile: (state, action) => {
      state.profile = action.payload;
    },
  },
});

export const { setConnect, setDisconnect, setProfile, setEthereum, setBech32Address } =
  AuthSlice.actions;

export default AuthSlice.reducer;
